import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import Home from "./components/Home";
import NavBar from "./components/NavBar";

function App() {
  // "images": ["https://via.placeholder.com/600x350"]

  return (
    <Router>
      <NavBar />
      <Home />
    </Router>
  );
}

export default App;
